/**
 * @generated SignedSource<<2c9286000d2433c1b7312809e5b22d17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type noteTemplateGqlApplyTemplateMutation$variables = {
  bypassNoteActivitySignals: boolean;
  makeDefault: boolean;
  noteId: string;
  templateId: string;
};
export type noteTemplateGqlApplyTemplateMutation$data = {
  readonly applyTemplate: {
    readonly note: {
      readonly id: string;
      readonly version: number;
    } | null;
    readonly ok: boolean;
  } | null;
  readonly rememberNoteTemplateSelection?: {
    readonly note: {
      readonly stream: {
        readonly template: {
          readonly id: string;
        } | null;
      };
    } | null;
    readonly ok: boolean;
  } | null;
};
export type noteTemplateGqlApplyTemplateMutation = {
  response: noteTemplateGqlApplyTemplateMutation$data;
  variables: noteTemplateGqlApplyTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bypassNoteActivitySignals"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "makeDefault"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v4 = {
  "kind": "Variable",
  "name": "noteId",
  "variableName": "noteId"
},
v5 = {
  "kind": "Variable",
  "name": "templateId",
  "variableName": "templateId"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "bypassNoteActivitySignals",
          "variableName": "bypassNoteActivitySignals"
        },
        (v4/*: any*/),
        (v5/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "concreteType": "ApplyTemplatePayload",
  "kind": "LinkedField",
  "name": "applyTemplate",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlApplyTemplateMutation",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "makeDefault",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RememberNoteTemplateSelection",
            "kind": "LinkedField",
            "name": "rememberNoteTemplateSelection",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStream",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "noteTemplateGqlApplyTemplateMutation",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "makeDefault",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RememberNoteTemplateSelection",
            "kind": "LinkedField",
            "name": "rememberNoteTemplateSelection",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStream",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a474a908710efea665b780637686fe4a",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlApplyTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlApplyTemplateMutation(\n  $noteId: ID!\n  $templateId: ID!\n  $makeDefault: Boolean!\n  $bypassNoteActivitySignals: Boolean!\n) {\n  applyTemplate(input: {noteId: $noteId, templateId: $templateId, bypassNoteActivitySignals: $bypassNoteActivitySignals}) {\n    ok\n    note {\n      id\n      version\n    }\n  }\n  rememberNoteTemplateSelection(noteId: $noteId, templateId: $templateId) @include(if: $makeDefault) {\n    ok\n    note {\n      stream {\n        template {\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f02df7c860380ed2b232d4107ebbda47";

export default node;
